import { Action, createReducer, on } from '@ngrx/store';
import { commonTurnActions } from './turn.action';
import { CommonTurnState, commonTurnIS } from './turn.state';

const commonTurnRegister = createReducer(
  commonTurnIS,
  on(commonTurnActions.setResultAction, (state, { result }) => ({
    ...state,
    result,
    totalTurns: state.result.length + result.length,
    turnsId: [...result.map((turn) => turn.id!)],
  })),

  on(commonTurnActions.addResultAction, (state, turn) => ({
    ...state,
    result: [...state.result, turn],
    totalTurns: state.result.length + 1,
    turnsId: [...state.turnsId, turn.id!],
  })),

  on(commonTurnActions.patchResultAction, (state, turn) => ({
    ...state,
    result: state.result.map((item) => {
      if (item.id === turn.id) {
        return turn;
      }
      return item;
    }),
  })),

  on(commonTurnActions.deleteResultAction, (state, { turn }) => ({
    ...state,
    result: state.result.filter((item) => item.id! !== +turn),
    totalTurns: state.result.length - 1,
    turnsId: state.result
      .filter((item) => item.id! !== +turn)
      .map((item) => item.id!),
  })),

  on(commonTurnActions.setLazyLoadResultAction, (state, lazyLoad) => ({
    ...state,
    lazyLoad,
  })),

  on(commonTurnActions.setAllDefaultAction, () => commonTurnIS),

  on(commonTurnActions.saveTurnFormAction, (state, { turn, formSaved }) => ({
    ...state,
    turn,
    formSaved,
  })),

  on(
    commonTurnActions.generatedRecipeAction,
    (state, { recipeFile, showRecipePdf }) => ({
      ...state,
      file: {
        recipeFile,
        showRecipePdf,
      },
    })
  )
);

export function commonTurnReducer(state: CommonTurnState, action: Action): any {
  return commonTurnRegister(state, action);
}
